// extracted by mini-css-extract-plugin
export default {"chatShell":"UBMlFNsd4PytkU9Zi0xw","chatShellContent":"TgQAnSTa1cd9flLxmXAW"};